<template>
  <div class="container">
    <basic-container v-loading="loading">
      <el-row type="flex" align="middle">
        <el-col :span="2" class="block-label">
          <div>圈子</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-select
              filterable
              remote
              value-key="circleId"
              placeholder="输入圈子名称搜索"
              v-model="post.circleName"
              :disabled="mode === 'edit'"
              :remote-method="remoteSearchCircle"
              @change="selectCircleChange">
              <el-option
                v-for="item in circlesOptions"
                :key="item.circleId"
                :label="item.circleName"
                :value="item">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle">
        <el-col :span="2"  class="block-label">
          <div>圈子成员</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-select
              remote
              filterable
              value-key="postedBy"
              placeholder="输入圈子成员搜索"
              v-model="post.postedByName"
              :disabled="mode === 'edit'"
              :remote-method="remoteSearchMembers"
              @change="selectCircleMemberChange">
              <el-option
                v-for="item in circleMembersOptions"
                :key="item.postedBy"
                :label="item.postedByName"
                :value="item">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <div class="divide"></div>
      <div class="header-title">
        发布供需
      </div>
      <div class="divide"></div>
      <div class="form-contant">
        <div class="form-contant-field">
          <div class="form-contant-header">
            <div class="header-left">
              <div class="post-tag" :class="{'empty' : isTagEmpty}">
                <el-select v-model="post.tagId" placeholder="选择供需类别" size="small" @change="setTag">
                  <el-option
                    v-for="(tag, index) in tags"
                    :key="index"
                    :label="tag.name"
                    :value="tag.id">
                  </el-option>
                </el-select>
              </div>
              <div class="post-subject" :class="{'empty' : isThemeTagEmpty}">
                <el-select :disabled="themeTags.length <= 0" v-model="post.themeTagId" placeholder="选择主题" size="small" @change="selectThemeTag">
                  <el-option
                    v-for="(themeTag, index) in themeTags"
                    :key="index"
                    :label="themeTag.name"
                    :value="themeTag.id">
                  </el-option>
                </el-select>
              </div>
              <div class="post-deadline" :class="{'empty' : isDeadlineEmpty}">
                <el-date-picker
                  v-model="post.expireIn"
                  type="date"
                  placeholder="截止日期"
                  format="yyyy/MM/dd 23:59"
                  :editable="false"
                  prefix-icon="icon-calendar"
                  value-format="yyyy-MM-dd 23:59:00"
                  :disabled="longTermEffective"
                >
                </el-date-picker>
              </div>
              <div class="long-term">
                <el-checkbox v-model="longTermEffective" @change="handleChangeLongTerm">长期有效</el-checkbox>
              </div>
            </div>
            <div class="header-right">
              <div class="post-cover-image">
                <cover-upload
                  :coverImage="post.coverImg"
                  @update-cover-image="updateCoverImage"
                ></cover-upload>
              </div>
            </div>
          </div>
          <div class="post-labels">
            <el-autocomplete
              class="input-new-tag"
              popper-class="autocomplete-tag-select"
              v-if="labelInputVisible"
              v-model="labelInputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputBlur"
              @select="handleSelect"
              :fetch-suggestions="queryTags"
              :trigger-on-focus="true"
            >
              <template slot-scope="{ item }">
                <div class="tag-item">
                  <span class="tag-name">{{ item.value }}</span>
                  <span class="tag-flag" v-if="item.isNewTag">创建新标签</span>
                </div>
              </template>
            </el-autocomplete>
            <el-button v-else-if="this.post.postTags.length < 3" class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
            <el-tag
              :key="index"
              v-for="(label, index) in post.postTags"
              closable
              :disable-transitions="false"
              @close="handleClose(label)">
              {{ label.tagName }}
            </el-tag>
          </div>
          <el-input v-model="post.title" maxlength="64"
            class="post-title"
            :class="{'empty' : isTitleEmpty}"
            @input="handleTitleInput"
            placeholder="输入帖子标题（64字以内）"
            show-word-limit />
        </div>
        <div class="form-contant-field">
          <RichTextEditor class="editor-wrap" v-model="post.content"
            placeholder="输入帖子内容"
            :maxChars="maxContentLength"
            :editable="editable"
            @getContentLength="getContentLength" />
        </div>
        <div class="form-contant-field fixed-bottom">
          <div>
            <el-checkbox v-model="post.isUseTemplate" class="form-checkbox" :disabled="!hasPostTemplate" @change="handleTemplate">使用模板</el-checkbox>
            <span class="reminder">参照模板发布，有机会获得更多曝光！</span>
          </div>
          <div>
            <el-button v-if="post.publishStatus !== 1" class="draft-button" type="primary" :disabled="isPublishClick" @click="publishPost(false)">保存草稿</el-button>
            <el-button class="publish-button" type="primary" :disabled="isPublishClick" @click="publishPost()">
              <i class="el-icon-s-promotion publish-icon" />
              <template v-if="mode === 'edit' && post.publishStatus === 1">
                保存
              </template>
              <template v-else>
                发布
              </template>
            </el-button>
          </div>
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
import moment from 'moment';
import { getFileKey, buildVideoThumbnail } from '@/util/util';
import { getTagsByType, getRelatedTags, createTags, searchTags } from '@/api/basic/tagtype';
import { getCirclesAdmin, getAllCircleMembersAdmin } from '@/api/post/circle';
import { createPost, updatePost, getPost } from '@/api/post/post';
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import CoverUpload from '@/components/post/cover-upload.vue';
import { getMembersByName } from '@/api/admin/member';
import { themeTagTypeId, postTagTypeId } from '@/config/const';

export default {
  data () {
    return {
      mode: 'create',
      loading: false,
      postLoading: null,
      isPublishClick: false,
      isUploadImage: false,
      isOverChoose: false,
      circlesOptions: [],
      circleMembersOptions: [],
      isPublicCircle: true,
      tags: [],
      post: {
        id: '',
        circleId: '',
        circleName: '',
        postedBy: '',
        postedByName: '',
        title: '',
        expireIn: '', // 截止日期
        postTags: [],
        themeTagId: '',
        themeTagName: '',
        content: '',
        getFromLocal: false,
        isUseTemplate: false,
        publishStatus: '',
        coverImg: '',
      },
      themeTags: [], // 帖子主题
      hasPostTemplate: false,
      contentLength: 0,
      maxContentLength: 20000,
      labelInputVisible: false,
      labelInputValue: '',
      // 长期有效复选框
      longTermEffective: false,
      // 标签最长字数
      maxPostTagLength: 30,
      editedPost: null,
      oldContent: '',
      oldThemeTagId: '',
      oldTag: {},
      isTagEmpty: false,
      isThemeTagEmpty: false,
      isDeadlineEmpty: false,
      isTitleEmpty: false,
      editable: false,
      isRememberUseTemplate: false,
      isHappyPass: false,
    };
  },
  components: {
    RichTextEditor,
    CoverUpload,
  },
  created() {
    this.fetchData();
  },
  mounted() {
    if (this.mode === 'create') {
      window.addEventListener('beforeunload', this.beforeClose);
    }
  },
  beforeDestroy() {
    if (this.mode === 'create') {
      window.removeEventListener('beforeunload', this.beforeClose);
    }
  },
  beforeRouteLeave(to, from, next) {
    // 阻止浏览器的前进后退使路由发生变化
    next(false);
    if (this.isHappyPass) {
      next();
    } else if (this.mode === 'create') {
      // 此处必须要加延迟执行，解决浏览器前进后退带来的闪现
      setTimeout(() => {
        this.$confirm('内容未发布，是否保存？', '', {
          confirmButtonText: '保存',
          showCancelButton: false,
        }).then(() => {
          localStorage.setItem('post', JSON.stringify(this.post));
          next();
        }).catch(() => {
          localStorage.removeItem('post');
          next();
        });
      }, 100);
    } else if (this.mode === 'edit') {
      // 此处必须要加延迟执行，解决浏览器前进后退带来的闪现
      setTimeout(() => {
        this.$confirm('内容未发布，是否保存？', '', {
          confirmButtonText: '保存',
          showCancelButton: false,
        }).then(() => {
          localStorage.setItem('editedPost', JSON.stringify(this.post));
          next();
        }).catch(() => {
          next();
          if (this.editedPost && this.post.id === this.editedPost.id) {
            localStorage.removeItem('editedPost');
          }
        });
      }, 100);
    }
  },
  watch: {
    'post.tagId': {
      handler() {
        this.changeEditable();
      },
    },
    'post.themeTagId': {
      handler() {
        this.changeEditable();
      },
    },
    themeTags() {
      this.changeEditable();
    },
    'post.expireIn': {
      handler(value) {
        if (value) {
          this.isDeadlineEmpty = false;
        }
      },
    },
  },
  methods: {
    getPostInfo() {
      if (this.editedPost && this.post.id === this.editedPost.id) {
        this.setEditedPostInfoFromLocal();
      } else {
        getPost(this.post.id).then(response => {
          const data = response.data;
          if (data.code === 0) {
            const post = data.data;
            this.post = Object.assign({}, post);
            this.post.postedBy = post.postedBy ? post.postedBy.id : '';
            this.post.postedByName = post.postedBy ? post.postedBy.name : '';
            this.oldThemeTagId = this.post.themeTagId;
            this.tags.forEach((item) => {
              if (item.id === this.post.tagId) {
                this.oldTag = item;
                this.getRelatedTags(item);
              }
            });
            if (!this.post.expireIn) {
              this.longTermEffective = true;
            }
          } else {
            this.$message({
              showClose: true,
              message: '无法查看该帖子详情',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取帖子详情失败',
            type: 'error'
          });
        });
      }
    },
    async getPostTags() {
      await getTagsByType({type: 2}).then(response => {
        if (Array.isArray(response.data.data)) {
          this.tags = response.data.data.map(x => {
            return {
              id: x.id,
              name: x.name
            };
          });
        }
        if (this.tags.length > 0) {
          const post = localStorage.getItem('post');
          try {
            this.editedPost = JSON.parse(localStorage.getItem('editedPost'));
          } catch (error) {
            console.log(error);
          }
          if (this.mode === 'create' && post) {
            this.setPostInfoFromLocal(post);
          }
        }
      });
    },
    // 获取与帖子类别相关的主题
    getRelatedTags(tag) {
      const query = {
        id: tag.id,
        typeId: themeTagTypeId,
      };
      getRelatedTags(query).then((response) => {
        const code = response.status;
        const data = response.data;
        if (code === 200) {
          this.themeTags = [];
          if (data.data) {
            data.data.forEach((record) => {
              this.themeTags.push({
                id: record.id,
                name: record.name,
              });
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    // getTemplate(tag, themeTagId, isUsed = true) {
    //   this.hasPostTemplate = false;
    //   const params = {
    //     tagId: tag.id,
    //     themeTagId,
    //   };
    //   getTemplate(params).then((response) => {
    //     const code = response.status;
    //     const data = response.data;
    //     if (code === 200) {
    //       tag.Template = data.data;
    //       if (isUsed && this.post.isUseTemplate) {
    //         this.handleTemplate(this.post.isUseTemplate);
    //       }
    //       if (tag.Template) {
    //         this.hasPostTemplate = true;
    //       } else {
    //         this.post.isUseTemplate = false;
    //       }
    //     }
    //   });
    // },
    handleTemplate(checked) {
      if (checked) {
        if (this.isRememberUseTemplate || !this.post.content) {
          this.usingTemplate();
        } else {
          this.$confirm('<b> 使用模板 </b>将清空当前编辑的<b> 正文内容 </b>，是否确认使用？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.usingTemplate();
          }).catch(() => {
            this.post.isUseTemplate = false;
          });
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (!this.post.content || this.post.content === this.oldContent) {
          this.post.content = '';
          this.oldContent = this.post.content;
          this.post.getFromLocal = false;
          this.isRememberUseTemplate = false;
        } else if (this.post.content !== this.oldContent || this.post.getFromLocal) {
          this.$confirm('<b> 取消使用模板 </b>将清空当前编辑的<b> 正文内容 </b>，是否确认取消？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.post.content = '';
            this.oldContent = this.post.content;
            this.post.getFromLocal = false;
            this.isRememberUseTemplate = false;
          }).catch(() => {
            this.post.isUseTemplate = true;
          });
        }
      }
    },
    usingTemplate() {
      let targetTag = null;
      this.tags.forEach((tag) => {
        if (tag.id === this.post.tagId) {
          targetTag = tag;
        }
      });
      if (targetTag && targetTag.Template) {
        this.post.content = targetTag.Template.content;
        this.isRememberUseTemplate = true;
      } else {
        this.post.content = '';
        this.isRememberUseTemplate = false;
      }
      this.oldContent = this.post.content;
      this.post.getFromLocal = false;
    },
    // 选中帖子类别时调用
    setTag(tagId) {
      const tag = this.tags.filter((item) => item.id === tagId)[0];
      if (this.mode === 'edit' && this.post.isUseTemplate) {
        this.post.isUseTemplate = false;
        this.switchTag(tag);
      } else if (!this.post.content || this.post.content === this.oldContent || !this.post.isUseTemplate) {
        // 如果内容为空，或者内容无变化，或者没有勾选使用模板，则不提示；若内容有变化，或者帖子内容是从local中读取，则提示
        this.switchTag(tag);
      } else if (this.post.content !== this.oldContent || this.post.getFromLocal) {
        this.$confirm(`切换<b> 类别 </b>将清空当前编辑的<b> 正文内容${this.post.themeTagId ? '和所选主题' : ''} </b>，是否确认切换？`, '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
        }).then(() => {
          this.post.content = '';
          this.switchTag(tag);
        }).catch(() => {
          this.post.tagId = this.oldTag.id;
          this.post.tagName = this.oldTag.name;
        });
      }
    },
    switchTag(tag) {
      this.post.tagId = tag.id;
      this.post.tagName = tag.name;
      this.oldTag = tag;
      this.post.themeTagId = '';
      this.post.themeTagName = '';
      this.oldThemeTagId = '';
      this.hasPostTemplate = false;
      this.post.getFromLocal = false;
      this.isTagEmpty = false;
      this.isThemeTagEmpty = false;
      this.getRelatedTags(tag);
    },
    // 选中主题时调用
    selectThemeTag(id) {
      if (this.mode === 'edit' && this.post.isUseTemplate) {
        this.post.isUseTemplate = false;
        this.switchThemeTag(id);
      } else if (!this.post.content || this.post.content === this.oldContent || !this.post.isUseTemplate) {
        // 如果内容为空，或者内容无变化，或者没有勾选使用模板，则不提示；若内容有变化，或者帖子内容是从local中读取，则提示
        this.switchThemeTag(id);
      } else if (this.post.content !== this.oldContent || this.post.getFromLocal) {
        this.$confirm('切换<b> 主题 </b>将清空当前编辑的<b> 正文内容 </b>，是否确认切换？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
        }).then(() => {
          this.post.content = '';
          this.switchThemeTag(id);
        }).catch(() => {
          if (this.oldThemeTagId) {
            this.themeTags.forEach((item) => {
              if (item.id === this.oldThemeTagId) {
                this.post.themeTagId = item.id;
                this.post.themeTagName = item.name;
              }
            });
          } else {
            this.post.themeTagId = '';
            this.post.themeTagName = '';
          }
        });
      }
    },
    switchThemeTag(id) {
      this.oldThemeTagId = id;
      this.hasPostTemplate = false;
      this.post.getFromLocal = false;
      this.isThemeTagEmpty = false;
      this.themeTags.forEach((item) => {
        if (item.id === id) {
          this.post.themeTagId = item.id;
          this.post.themeTagName = item.name;
        }
      });
      let targetTag = null;
      this.tags.forEach((tag) => {
        if (tag.id === this.post.tagId) {
          targetTag = tag;
        }
      });
    },
    getCircles() {
      let query = {circleType: 0, size: 20, name: this.post.circleName};
      getCirclesAdmin(query).then(response => {
        if (Array.isArray(response.data.data.records)) {
          this.circlesOptions = response.data.data.records.map(x => {
            return {
              circleId: x.id,
              circleName: x.circleName,
              isPublic: x.isPublic,
            };
          });
        }
      });
    },
    getCircleMembers() {
      if (this.isPublicCircle) {
        this.getMembersByName();
      } else {
        let query = {circleId: this.post.circleId, size: 20, nickname: this.post.postedByName};
        getAllCircleMembersAdmin(query).then(response => {
          if (Array.isArray(response.data.data.records)) {
            this.circleMembersOptions = response.data.data.records.map(x => {
              return {
                postedBy: x.id,
                postedByName: x.name
              };
            });
          }
        });
      }
    },
    getMembersByName() {
      let query = { size: 20, name: this.post.postedByName };
      getMembersByName(query).then((response) => {
        if (Array.isArray(response.data.data.records)) {
          this.circleMembersOptions = response.data.data.records.map(x => {
            return {
              postedBy: x.id,
              postedByName: x.name
            };
          });
        }
      });
    },
    remoteSearchCircle(params) {
      if (params && params.trim()) {
        this.post.circleName = params.trim();
        this.getCircles();
      }
    },
    remoteSearchMembers(params) {
      if (params && params.trim()) {
        this.post.postedByName = params.trim();
        this.getCircleMembers();
      }
    },
    selectCircleChange(params) {
      if (params) {
        this.post.postedByName = '';
        this.post.circleId = params.circleId;
        this.post.circleName = params.circleName;
        if (params.isPublic) {
          this.isPublicCircle = true;
        } else {
          this.isPublicCircle = false;
        }
        this.getCircleMembers();
      }
    },
    selectCircleMemberChange(params) {
      if (params) {
        this.post.postedBy = params.postedBy;
        this.post.postedByName = params.postedByName;
      }
    },
    prePublishPost() {
      let resultOK = true;
      if (this.post.circleId === undefined || this.post.circleId === null || this.post.circleId === '') {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请选择圈子',
          type: 'error',
        });
      } else if (this.post.postedBy === undefined || this.post.postedBy === null || this.post.postedBy === '') {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请选择圈子成员',
          type: 'error',
        });
      } else if (!this.post.tagId) {
        resultOK = false;
        this.isTagEmpty = true;
        this.$message({
          showClose: true,
          message: '请选择供需类别',
          type: 'error',
        });
      } else if ((this.themeTags.length > 0) && (this.post.themeTagId === undefined || this.post.themeTagId === null || this.post.themeTagId === '')) {
        resultOK = false;
        this.isThemeTagEmpty = true;
        this.$message({
          showClose: true,
          message: '请选择主题',
          type: 'error',
        });
      } else if (!this.longTermEffective && !this.post.expireIn) {
        resultOK = false;
        this.isDeadlineEmpty = true;
        this.$message({
          showClose: true,
          message: '请选择截止日期',
          type: 'error',
        });
      } else if (this.post.title.trim().length < 1) {
        resultOK = false;
        this.isTitleEmpty = true;
        this.$message({
          showClose: true,
          message: '请填写标题',
          type: 'error',
        });
      } else if (this.post.content === undefined || this.post.content.trim().length < 1) {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请填写帖子内容',
          type: 'error',
        });
      } else {
        if (this.contentLength > this.maxContentLength) {
          resultOK = false;
          this.$message({
            showClose: true,
            message: `帖子内容最多${this.maxContentLength}字符`,
            type: 'error',
          });
        }
      }
      return resultOK;
    },
    preSaveDraft() {
      let resultOK = true;
      if (this.post.circleId === undefined || this.post.circleId === null || this.post.circleId === '') {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请选择圈子',
          type: 'error',
        });
      } else if (this.post.postedBy === undefined || this.post.postedBy === null || this.post.postedBy === '') {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请选择圈子成员',
          type: 'error',
        });
      } else if (!this.post.tagId && !this.post.expireIn && this.post.postTags < 1 && !this.post.title && !this.post.content && !this.post.coverImg) {
        resultOK = false;
        this.$message({
          showClose: true,
          message: '请至少填写一项后再保存草稿',
          type: 'error',
        });
        window.scrollTo(0, 0);
      } else if (this.contentLength > this.maxContentLength) {
        resultOK = false;
        this.$message({
          showClose: true,
          message: `帖子内容最多${this.maxContentLength}字符`,
          type: 'error',
        });
      }
      return resultOK;
    },
    modifyPost(params, modify, msg, errorMsg, request) {
      modify(params).then((response) => {
        const code = response.status;
        const data = response.data;
        if (code === 200) {
          this.isPublishClick = false;
          if (data.data) {
            this.$message({
              showClose: true,
              message: msg,
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.isHappyPass = true;
                if (request === 'create') {
                  localStorage.removeItem('post');
                  this.post.id = data.data;
                  this.$router.push({ path: `/post/posts/detail/${data.data}` });
                } else {
                  if (this.editedPost && this.post.id === this.editedPost.id) {
                    localStorage.removeItem('editedPost');
                  }
                  this.$router.push({ path: `/post/posts/detail/${this.post.id}` });
                }
              }
            });
          }
        } else {
          this.isPublishClick = false;
          this.$message({
            showClose: true,
            message: data.msg || errorMsg,
            type: 'error',
          });
        }
      }).catch(() => {
        this.isPublishClick = false;
        this.$message({
          showClose: true,
          message: errorMsg,
          type: 'error',
        });
      });
    },
    publishPost(isPublish = true) {
      this.isPublishClick = true;
      if (isPublish) {
        if (!this.prePublishPost()) {
          this.isPublishClick = false;
          return;
        }
        this.post.publishStatus = 1;
      } else {
        if (!this.preSaveDraft()) {
          this.isPublishClick = false;
          return;
        }
        this.post.publishStatus = 0;
      }
      const postData = {};
      postData.circleId = this.post.circleId;
      postData.circleName = this.post.circleName;
      postData.tagId = this.post.tagId;
      postData.tagName = this.post.tagName;
      postData.title = this.post.title;
      postData.content = this.post.content;
      postData.postType = 0;
      postData.themeTagId = this.post.themeTagId;
      postData.themeTagName = this.post.themeTagName;
      postData.expireIn = this.post.expireIn;
      postData.postTags = this.post.postTags;
      postData.isUseTemplate = this.post.isUseTemplate;
      postData.contentType = 1;
      postData.publishStatus = this.post.publishStatus;
      postData.coverImg = this.post.coverImg;
      if (this.mode === 'create') {
        postData.postedBy = this.post.postedBy;
        postData.postedByName = this.post.postedByName;
        this.modifyPost(postData, createPost, isPublish ? '帖子创建成功' : '草稿保存成功', isPublish ? '帖子创建失败，请稍后重试！' : '草稿保存失败', 'create');
      } else {
        postData.id = this.post.id;
        this.modifyPost(postData, updatePost, isPublish ? '帖子编辑成功' : '草稿保存成功', isPublish ? '帖子编辑失败，请稍后重试！' : '草稿保存失败', 'edit');
      }
    },
    handleClose(tag) {
      this.post.postTags.splice(this.post.postTags.indexOf(tag), 1);
    },
    showInput() {
      this.labelInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.labelInputValue.trim();
      if (this.post.postTags.length >= 3) {
        this.$message({
          message: '最多添加3个标签',
          type: 'warning',
        });
        return;
      }
      if (inputValue.length > this.maxPostTagLength) {
        this.$message({
          message: `标签最多${this.maxPostTagLength}个字符`,
          type: 'warning',
        });
        return;
      }
      if (inputValue) {
        // 不允许添加重复标签
        const index = this.post.postTags.findIndex((value, index, arr) => value.tagName === inputValue);
        if (index === -1) {
          const newTag = {
            name: inputValue,
            type: 6,
          };
          this.createTags(newTag);
        } else {
          this.$message({
            showClose: true,
            message: '不允许添加重复的标签',
            type: 'warning',
          });
        }
      }
      this.labelInputVisible = false;
      this.labelInputValue = '';
    },
    handleInputBlur() {
      setTimeout(() => {
        this.labelInputVisible = false;
        this.labelInputValue = '';
      }, 200);
    },
    // 查找与类别和主题相关的标签
    queryTagsRelatedSubjectAndTheme(queryString, cb) {
      const query = {
        id: this.post.tagId,
        typeId: postTagTypeId,
      };
      let subjectRelatedPostTags = [];
      getRelatedTags(query).then((response) => {
        const code = response.data.code;
        const data = response.data.data;
        if (code === 0 && data) {
          data.forEach((record) => {
            subjectRelatedPostTags.push({
              id: record.id,
              value: record.name,
            });
          });
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        if (this.post.themeTagId) {
          const query2 = {
            id: this.post.themeTagId,
            typeId: postTagTypeId,
          };
          const themeRelatedPostTag = [];
          getRelatedTags(query2).then((response) => {
            const code = response.data.code;
            const data = response.data.data;
            if (code === 0 && data) {
              data.forEach((record) => {
                themeRelatedPostTag.push({
                  id: record.id,
                  value: record.name,
                });
              });
            }
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            subjectRelatedPostTags = subjectRelatedPostTags.filter((item) => themeRelatedPostTag.find((item2) => item.id === item2.id));
            cb(subjectRelatedPostTags);
          });
        } else {
          cb(subjectRelatedPostTags);
        }
      });
    },
    // 模糊查找标签
    queryTags(queryString, cb) {
      if (!queryString.trim()) {
        if (this.post.tagId) {
          this.queryTagsRelatedSubjectAndTheme(queryString, cb);
        } else {
          cb(null);
        }
      } else {
        searchTags(queryString.trim()).then((response) => {
          const code = response.status;
          const data = response.data;
          const results = [];
          if (code === 200) {
            if (data.data) {
              data.data.records.forEach((record) => {
                results.push({
                  id: record.id,
                  value: record.name,
                });
              });
              const inputValue = this.labelInputValue.trim();
              const item = results.filter((item) => item.value === inputValue);
              if (item.length === 0) {
                results.unshift({
                  id: '',
                  value: inputValue,
                  isNewTag: true,
                });
              }
              // 调用 callback 返回建议列表的数据
              cb(results);
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    },
    // 选中模糊查找的标签
    handleSelect(item) {
      const inputValue = this.labelInputValue.trim();
      if (this.post.postTags.length >= 3) {
        this.$message({
          message: '最多添加3个标签',
          type: 'warning',
        });
        return;
      }
      if (inputValue.length > this.maxPostTagLength) {
        this.$message({
          message: `标签最多${this.maxPostTagLength}个字符`,
          type: 'warning',
        });
        return;
      }
      if (inputValue) {
        // 不允许添加重复标签
        const index = this.post.postTags.findIndex((value, index, arr) => value.tagName === inputValue);
        if (index === -1) {
          if (item.isNewTag) {
            const newTag = {
              name: inputValue,
              type: 6,
            };
            this.createTags(newTag);
          } else {
            this.post.postTags.push({
              tagId: item.id,
              tagName: item.value,
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: '不允许添加重复的标签',
            type: 'warning',
          });
        }
      }
      this.labelInputVisible = false;
      this.labelInputValue = '';
    },
    createTags(newTag) {
      createTags(newTag).then((response) => {
        const code = response.status;
        const data = response.data;
        if (code === 200) {
          if (data.code === 0) {
            this.post.postTags.push({
              tagId: data.data,
              tagName: newTag.name,
            });
          }
        }
      });
    },
    setPostInfoFromLocal(post) {
      try {
        this.post = JSON.parse(post);
        if (!this.post.expireIn) {
          this.longTermEffective = true;
        }
        this.post.getFromLocal = true;
        const tag = this.tags.filter((item) => item.id === this.post.tagId)[0];
        this.oldTag = tag;
        this.hasPostTemplate = false;
        this.oldThemeTagId = this.post.themeTagId;
        this.getRelatedTags(tag);
      } catch (error) {
        console.log(error);
      }
    },
    beforeClose(event) {
      event.returnValue = '您输入的内容尚未保存，确定离开此页面吗？';
    },
    handleChangeLongTerm(checked) {
      if (checked) {
        this.post.expireIn = '';
        this.isDeadlineEmpty = false;
      }
    },
    setEditedPostInfoFromLocal() {
      this.post = this.editedPost;
      this.post.getFromLocal = true;
      this.oldThemeTagId = this.post.themeTagId;
      this.tags.forEach((item) => {
        if (item.id === this.post.tagId) {
          this.hasPostTemplate = false;
          this.oldTag = item;
          this.getRelatedTags(item);
        }
      });
      if (!this.post.expireIn) {
        this.longTermEffective = true;
      }
    },
    async fetchData() {
      if (this.$route.query.id) {
        this.mode = 'edit';
        this.post.id = this.$route.query.id;
      }
      await this.getPostTags();
      if (this.mode === 'edit') {
        this.getPostInfo();
      } else {
        this.getCircles();
      }
    },
    getContentLength(length) {
      this.contentLength = length;
    },
    handleTitleInput(title) {
      if (title) {
        this.isTitleEmpty = false;
      }
    },
    changeEditable() {
      if (!this.post.tagId) {
        this.editable = false;
      } else if (this.themeTags.length > 0 && !this.post.themeTagId) {
        this.editable = false;
      } else {
        this.editable = true;
      }
    },
    updateCoverImage(coverImage) {
      this.post.coverImg = coverImage;
    },
  },
};
</script>

<style lang="scss">
.el-autocomplete-suggestion.autocomplete-tag-select {
  width: 318.5px !important;
  max-width: 541px !important;
  width: auto !important;
  .el-scrollbar {
    .el-autocomplete-suggestion__wrap {
      .el-autocomplete-suggestion__list {
        .tag-item {
          display: flex;
          justify-content: space-between;
          .tag-flag {
            font-size: 14px;
            color: #005FB4;
            letter-spacing: -0.17px;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.container {
  .divide {
    height: 10px;
  }

  .header-title {
    background: #FDFDFD;
    padding: 26px 34px;
    border-radius: 8px;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    letter-spacing: 0;
    border: 1px solid #E9E9E9;
  }

  .form-contant {
    border: none;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #E9E9E9;
    .editor-wrap {
      margin: 1px 0 0 1px;
      position: relative;
    }
    .form-contant-field {
      text-align: left;
      margin-bottom: 16px;
      .post-title.empty {
        border: 1px solid #F14856;
      }
      .post-title {
        background: #F6F5F5;
        border-radius: 4px;
        font-size: 22px;
        letter-spacing: 0;
        /deep/ .el-input__inner {
          border: 1px solid #E9EFF4;
          height: 50px;
          color: #333;
        }
        /deep/ .el-input__inner::placeholder {
          color: #D8D8D8;
        }
      }
      /deep/ .is-checked {
        border-color: #4DA1FF;
        .el-checkbox__inner {
          border-color: #4DA1FF;
          background-color: #4DA1FF;
        }
        .el-checkbox__label {
          color: #606266;
        }
      }
      .form-contant-header {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .header-left {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-right: 16px;
          flex: 1;
        }
        .post-tag {
          margin-right: 16px;
          margin-bottom: 8px;
          border: 1px solid #E9EFF4;
          border-radius: 4px;
          flex: 1;
          min-width: 40%;
          /deep/ .el-input--small {
            .el-input__inner {
              height: 45px !important;
              border: none;
              font-size: 16px;
              color: #333;
            }
            .el-input__inner::placeholder {
              color: #999999;
            }
          }
        }
        .post-tag.empty {
          border: 1px solid #F14856;
        }
        .post-subject {
          display: inline-block;
          margin-bottom: 8px;
          border: 1px solid #E9EFF4;
          border-radius: 4px;
          flex: 1;
          min-width: 40%;
          /deep/ .el-input--small {
            .el-input__inner {
              height: 45px !important;
              border: none;
              font-size: 16px;
              color: #333;
            }
            .el-input__inner::placeholder {
              color: #999999;
            }
          }
        }
        .post-subject.empty {
          border: 1px solid #F14856;
        }
        .post-deadline.empty {
          border: 1px solid #F14856;
        }
        .post-deadline {
          margin-right: 16px;
          border: 1px solid #E9EFF4;
          border-radius: 4px;
          flex: 1;
          min-width: 40%;
          /deep/ .el-date-editor.el-input {
            .el-input__inner {
              height: 45px;
              border: none;
              font-size: 16px;
              color: #333;
              padding-left: 15px;
            }
            .el-input__inner::placeholder {
              color: #999999;
            }
            .el-input__prefix {
              right: 5px;
              left: auto;
              .icon-calendar {
                background: url(../../../static/images/editor/calendar.svg) no-repeat center;
                display: block;
              }
            }
            .el-input__suffix {
              right: 10%;
              i {
                font-size: 16px;
              }
            }
          }
        }
        .long-term {
          flex: 1;
          min-width: 40%;
          border: 1px solid #fff;
        }
      }
      .post-labels {
        display: flex;
        align-items: center;
        min-height: 45px;
        background: #ffffff;
        border: 1px solid #E9EFF4;
        border-radius: 4px;
        flex: 1;
        padding: 0 15px;
        margin-bottom: 16px;
        flex-wrap: wrap;
        /deep/ .el-tag {
          border: none;
          height: 28px;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        /deep/ .el-tag:not(:last-child) {
          margin-right: 8px;
        }
        .input-new-tag {
          width: 82px;
          vertical-align: bottom;
          margin-right: 8px;
        }
        .button-new-tag {
          color: #4DA1FF;
          font-size: 11px;
          border: 1px solid #4DA1FF;
          padding: 8px 11px;
          margin-right: 8px;
        }
      }
      .form-checkbox {
        /deep/ .el-checkbox__label {
          font-size: 16px;
          color: #333333;
          letter-spacing: -0.2px;
          line-height: 27px;
          font-size: 16px;
        }
      }
      .reminder {
        margin-left: 24px;
        font-size: 16px;
        color: #999999;
        letter-spacing: -0.2px;
        line-height: 27px;
      }
      .draft-button {
        background-color: #ffffff;
        border-radius: 26.18px;
        border: 1px solid #005FB4;
        width: 120px;
        height: 40px;
        padding: 0;
        font-size: 18px;
        color: #005FB4;
        vertical-align: middle;
      }
      .publish-button {
        background-color: #005FB4;
        border-radius: 24px;
        border: none;
        width: 120px;
        height: 40px;
        padding: 0;
        font-size: 18px;
        margin-left: 16px;
        vertical-align: middle;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          .publish-icon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
          background: url(../../../static/images/editor/publish.svg);
          }
        }
      }
    }
    .form-contant-field.fixed-bottom {
      position: absolute;
      left: 10px;
      bottom: 0;
      z-index: 1;
      box-sizing: border-box;
      width: calc(100% - 20px);
      margin: 0;
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 20px 70px 20px 40px;
    }
  }
  .dialog-cancel-comfirm {
    width: 400px;
    /deep/ .el-dialog__header {
      text-align: center;
      padding: 20px 20px 10px;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      line-height: 26px;
    }
    .dialog-cancel-confirm-content {
      font-size: 15px;
      color: #666666;
      letter-spacing: 0;
      line-height: 23px;
    }
    /deep/ .el-dialog__footer {
      text-align: center;
      .dialog-footer-button {
        width: 80px;
        height: 33px;
        line-height: 8px;
        :hover {
          background: #E9E9E9;
          color: #E9E9E9;
        }
      }
      .dialog-footer-button-comfirm {
        background-color: #E27B48;
        border-color: #E27B48;
      }
      .dialog-footer-button-cancel {
        border-color: #E27B48;
        color: #E27B48;
      }
    }
  }
}
</style>
